module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/329ed0ca87b67705aa4a08eef0bddde7.png";